import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const serviceAreaApi = createApi({
  reducerPath: 'serviceAreaApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/service_areas' }),
  endpoints: (builder) => ({
    getServiceAreas: builder.query({
      query: (searchParams) => ({ url: `?${searchParams}` }),
      transformResponse: (response) =>
        response.service_areas.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
    })
  })
})

const { useGetServiceAreasQuery } = serviceAreaApi

export { serviceAreaApi, useGetServiceAreasQuery }
